export default "__VITE_ASSET__4mKjXvyJ__"